import dynamic from "next/dynamic";

export const DynamicContent068 = dynamic(() => import("./Content068"), {
  suspense: true,
});
